// document.addEventListener("DOMContentLoaded", function () {

//   if (window.location.pathname !== "/pages/never-miss-a-special-day") {
//     return;
//   }

//   const params = new URLSearchParams(window.location.search);
//   const email = params.get("email");
//   console.log(email, 'email here...')
//   if (!email) return;

//   setTimeout(() => {
//     const formEmbed = document.querySelector("shopify-forms-embed");
//     if (!formEmbed) return;

//     const shadowRoot = formEmbed.shadowRoot;
//     if (!shadowRoot) return;

//     const emailInput = shadowRoot.querySelector("#email");
//     if (emailInput) {
//       emailInput.value = email;
//       emailInput.dispatchEvent(new Event("input", { bubbles: true }));
//     }

//   }, 3600);

  

// });


// -----------------------------

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname !== "/pages/never-miss-a-special-day") {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const email = params.get("email");
  console.log(email, 'email...')
  if (!email) return;

  setTimeout(() => {
    const formEmbed = document.querySelector("shopify-forms-embed");
    console.log(formEmbed, 'form embed4....')

    if (!formEmbed) return;

    const shadowRoot = formEmbed.shadowRoot;
    if (!shadowRoot) return;

    const emailInput = shadowRoot.querySelector("#email");

    if (emailInput) {
      emailInput.value = email;
      emailInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

  }, 4000);
  
});

function waitForEmbed() {
  const embed = document.querySelector("shopify-forms-embed");

  if (embed && embed.shadowRoot) {
    applyLayout();
  } else {
    requestAnimationFrame(waitForEmbed);
  }
}

function applyLayout() {
  const embed = document.querySelector("shopify-forms-embed");
  if (!embed || !embed.shadowRoot) return;

  const shadow = embed.shadowRoot;

  if (shadow.querySelector("#custom-shadow-style")) return;

  const style = document.createElement("style");
  style.id = "custom-shadow-style";
  style.textContent = `

  /* ============================= */
  /* MOBILE FIRST RESET           */
  /* ============================= */

  ._formBannerHeading_z5ku3_9 {
    justify-content: center !important;
    font-family: "Bodoni Moda", serif !important;
  }

  @media (min-width: 769px) {

    :host {
      --container-max-w: 100% !important;
      --inline-container-max-width: 100% !important;
    }

    /* ============================= */
    /* MAIN GRID                    */
    /* ============================= */

    ._formFieldset_cit2d_82 {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px !important;
      width: 100% !important;
    }

    /* ============================= */
    /* GRID POSITION CONTROL        */
    /* ============================= */

    ._formFieldset_cit2d_82 > *:nth-child(1){
      display: none;
    }

    ._formFieldset_cit2d_82 > *:nth-child(2),
    ._formFieldset_cit2d_82 > *:nth-child(3) {
      grid-column: span 1 !important;
    }
    ._formFieldset_cit2d_82 > *:nth-child(5),
    ._formFieldset_cit2d_82 > *:nth-child(6) {
      grid-column: span 1 !important;
    }

    ._formFieldset_cit2d_82 > *:nth-child(4) {
      grid-column: span 2 !important;
    }

    ._formFieldContainer_1mxsl_5 {
      align-self: end;
    }

    ._formFieldset_cit2d_82 > *:nth-child(7),
    ._formFieldset_cit2d_82 > *:nth-child(8) {
      grid-column: span 1 !important;
    }
    

    ._formFieldset_cit2d_82 > *:nth-child(9) {
      grid-column: span 2 !important;
    }

    ._formFieldset_cit2d_82 > *:nth-child(10),
    ._formFieldset_cit2d_82 > *:nth-child(11) {
      grid-column: span 1 !important;
    }

    // ._formFieldset_cit2d_82 > *:nth-child(12),
    // ._formFieldset_cit2d_82 > *:nth-child(13) {
    //   grid-column: span 1 !important;
    // }

    // /* Submit Button */
    //  {
    //   grid-column: span 2 !important;
    // }

    // /* Disclaimer */
    // ._formFieldset_cit2d_82 > *:nth-child(13) {
    //   grid-column: span 2 !important;
    // }

    /* ============================= */
    /* DATE INNER GRID              */
    /* ============================= */

    ._dateFieldContainer_rzr7e_5 {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
    }

    /* ============================= */
    /* INPUT CLEAN DESIGN           */
    /* ============================= */

    ._formInputField_nag3b_7 {
      border-radius: 0px !important;
      border: 0.5px solid black !important;
      width: 100% !important;
      box-sizing: border-box !important;
      box-shadow: none !important;
  }

    ._formInputField_nag3b_7:focus {
      outline: none !important;
      border-color: #000 !important;
    }

    input._formInputField_nag3b_7:focus-visible {
      box-shadow: unset !important;
    }

    /* ============================= */
    /* SUBMIT BUTTON                */
    /* ============================= */

    button._formSubmitButton_cit2d_96 {
      grid-column: span 2 !important;
      width: 500px !important;
      max-width: 100% !important;
      margin: 2px auto 0 auto !important;
      padding: 16px !important;
      font-weight: 600 !important;
      font-size: 15px !important;
      border-radius: 0px !important;
      cursor: pointer !important;
      transition: opacity 0.2s ease !important;
    }

    ._formSubmitButton_cit2d_96:hover {
      opacity: 0.9 !important;
    }

    /* Center disclaimer text */

    ._formDisclaimer_cit2d_38 {
      grid-column: span 2 !important;
      text-align: center !important;
      margin-top: 12px !important;
    }

    section._formHeader_cit2d_24 {
      text-align: center !important;
    }

    ._formContainer_1q1d2_30._tight_1q1d2_271 {
      padding: 60px 20px !important;
    }

    ._formBannerContainer_z5ku3_1 {
      text-align: center !important;
      max-width: 600px !important;
      margin: 0 auto !important;
    }

    ._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 {
      font-family: "Bodoni Moda", serif;
      font-size: 18px !important;
      line-height: 1.6 !important;
      color: #444 !important;
    }
  }


  /* ============================= */
  /* MOBILE                       */
  /* ============================= */

  @media (max-width: 768px) {

  ._formInputField_nag3b_7 {
      border-radius: 0px !important;
      border: 1px solid black !important;
      width: 100% !important;
      box-sizing: border-box !important;
      box-shadow: none !important;
  }

    input._formInputField_nag3b_7:focus-visible {
      box-shadow: unset !important;
    }

    button._formSubmitButton_cit2d_96{
      border-radius: 0px !important;
    }
  }

  form._formFieldset_cit2d_82{
    padding: 5px 0 !important;
    
  }
  `;

  shadow.appendChild(style);
}

waitForEmbed();
const block = document.getElementById(
  "shopify-block-AQTVXS1lUVTJ3TlVpc__cd180c07-fd57-42be-8312-f1a62a56d25b"
);

if (block) {
  block.classList.add("grid-container");
}

window.initializeProductGallery = function () {

    const mainSliderEl = document.querySelector('.x-product-main-slider');
    const thumbSliderEl = document.querySelector('.x-product-thumb-slider');

    if (!mainSliderEl || !thumbSliderEl) return;

    /*
    -----------------------------------
    DESTROY OLD SWIPERS
    -----------------------------------
    */

    if (mainSliderEl.swiper) {
        mainSliderEl.swiper.destroy(true, true);
    }

    if (thumbSliderEl.swiper) {
        thumbSliderEl.swiper.destroy(true, true);
    }

    /*
    -----------------------------------
    THUMB SLIDER
    -----------------------------------
    */

    const thumbSwiper = new Swiper('.x-product-thumb-slider', {
        slidesPerView: 4,
        spaceBetween: 8,
        watchSlidesProgress: true,

        navigation: {
            nextEl: '.x-product-thumb-next',
            prevEl: '.x-product-thumb-prev',
        },

        breakpoints: {
            320: {
                slidesPerView: 4,
            },

            768: {
                slidesPerView: 4,
            }
        }
    });

    /*
    -----------------------------------
    MAIN SLIDER
    -----------------------------------
    */

    const mainSwiper = new Swiper('.x-product-main-slider', {

        slidesPerView: 1,
        spaceBetween: 10,

        navigation: {
            nextEl: '.x-product-main-next',
            prevEl: '.x-product-main-prev',
        },

        thumbs: {
            swiper: thumbSwiper,
        }
    });

    /*
  -----------------------------------
  SET ACTIVE VARIANT IMAGE
  -----------------------------------
  */

  // const currentVariantId =
  // document.querySelector('select[name="id"]')?.value ||
  // document.querySelector('input[name="id"]')?.value;

  const currentVariantId =
document.querySelector('input[name="id"]')?.value;

  if (currentVariantId && window.productVariants) {

      const currentVariant = window.productVariants.find(
          variant => String(variant.id) === String(currentVariantId)
      );

if (currentVariant?.featured_image) {

    const mediaId =
    currentVariant.featured_image.id;

    let imageIndex = 0;

    document
    .querySelectorAll('.x-product-main-slider .swiper-slide')
    .forEach((slide, index) => {

        if (
            String(slide.dataset.mediaId) ===
            String(mediaId)
        ) {
            imageIndex = index;
        }

    });

    mainSwiper.slideTo(imageIndex);

    thumbSwiper.slideTo(imageIndex);

}

  }

};

document.addEventListener("DOMContentLoaded", () => {
  window.initializeProductGallery?.();
});